import React, { useMemo, useState, useEffect } from 'react';
import styled from 'styled-components'
import { PFileList,PFileItem } from '../../sidebar'
const iconExport = '/assets/images/icon/Icon_Export.svg'
const ArrowRightIcon = '/assets/images/arrow/arrow_right_up.svg'

interface Props {
  linkSet?: any;
  caseInfo?: any;
  setShowFileModal?: React.Dispatch<React.SetStateAction<boolean>>;
   disabled?: boolean;
}

const PAttachmentFile = ({ linkSet, setShowFileModal, disabled }: Props) => {
  const fileButtons: PFileItem[] = useMemo(() => [
    {
      content: '재산명세서',
      icon: 'invoice.svg',
      link: linkSet?.buttonLink?.propertyStat || '',
      disabled: !linkSet?.buttonLink?.propertyStat,
    },
    {
      content: '감정평가서',
      icon: 'search.svg',
      link: linkSet?.buttonLink?.appraisal || '',
      disabled: !linkSet?.buttonLink?.appraisal,
    },
    {
      content: '건물등기',
      icon: 'building.svg',
      link: linkSet?.buttonLink?.buildingRegister || '',
      disabled: !linkSet?.buttonLink?.buildingRegister,
    },
    {
      content: '토지등기',
      icon: 'layer.svg',
      link: linkSet?.buttonLink?.landRegister || '',
      disabled: !linkSet?.buttonLink?.landRegister,
    },
    {
      content: '압류재산정보',
      icon: 'lock.svg',
      link: linkSet?.buttonLink?.assetDetail || '',
      disabled: !linkSet?.buttonLink?.assetDetail,
    },
  ], [linkSet]);

    return (
      <div>
        <DetailContainer>
            <TitleWrapper>
                <AttchmentTitle>첨부파일</AttchmentTitle>
                <ExportButton onClick={() => setShowFileModal?.(true)}>
                    <img src={iconExport} alt="내보내기" />
                    일괄 내보내기
                </ExportButton>
            </TitleWrapper>
              <ContentWrapper>
          {fileButtons.map((item, idx) => {
            const isDisabled = item.disabled ?? !item.link;

            const handleClick = () => {
              if (item.isModal) {
                setShowFileModal?.(true);
                return;
              }
              if (isDisabled) return;
              window.open(item.link, '_blank');
            };

            return (
              <ContentBox
                key={idx}
                onClick={handleClick}
                style={{
                  opacity: isDisabled ? 0.2 : 1,
                  pointerEvents: isDisabled ? 'none' : 'auto',
                  cursor: isDisabled ? 'not-allowed' : 'pointer',
                }}
              >
                {item.content}
              </ContentBox>
            );
          })}
        </ContentWrapper>
        <ContentWrapper style={{marginTop:'24px'}}>
          <ContentBox2 onClick={() => {
            window.open(linkSet.detailLink.url);
          }}>온비드 공매 이동
            <img src={ArrowRightIcon} alt="" />  
          </ContentBox2>
        </ContentWrapper>
        </DetailContainer>
      </div>
      )}

export default PAttachmentFile
const DetailContainer = styled.div`
  width: 100%;
  height: fit-content;
  padding: 32px 16px;
  background-color: #ffffff;
`;

const AttchmentTitle = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  gap: 24px;
  color: #222222;
  font-size: 18px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  line-height: 26.1px;
  word-wrap: break-word;
`

const ExportButton = styled.span`
  border: 1px solid rgb(229, 232, 234);
  border-radius: 4px;
  padding: 4px 6px;
  font-size: 14px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 14.5px;
  word-wrap: break-word;
  display: flex;
  align-items: center;
  gap: 2px;
  cursor: pointer;
`
const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`

const ContentWrapper = styled.div`
  padding: 12px 16px;
  border: 1px solid #70737C29;
  border-radius: 8px;
`
 
const ContentBox = styled.div`
  padding: 12px 0;
  border-bottom: 1px solid #70737C29;
  font-size: 14px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 26.1px;
  word-wrap: break-word;
  cursor: pointer;
  &:first-child {
  padding: 4px 0 12px;
  }
  &:last-child {
  padding: 12px 0 0;
  border: none;
  }
`

const ContentBox2 = styled.div`
  padding: 12px 0;
  font-size: 14px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  line-height: 26.1px;
  word-wrap: break-word;
  cursor: pointer;
  padding: 0;
  color: #004E97; 
  display: flex;
  justify-content: space-between;
  align-items: center;
`